import { useState, type CSSProperties, type ReactElement } from 'react';
import { COULEURS, styleBouton } from '../../../app/styles.js';
import type { Designation } from './source.js';

/**
 * Désignation complète d'une ligne de devis ou de facture (lignes détaillées, 30/10/2026), comme les devis actuels du Cabinet MAAT :
 * code, intitulé, puis chaque section en gras et ses sous-lignes. Au-delà de quatre sections, le détail est plié (trois visibles) et
 * se déplie par un bouton qui dit son état (`aria-expanded`). Partagée par D08 et le portail (taille de police héritée).
 */
export const SECTIONS_AVANT_PLIAGE = 4;
const VISIBLES_PLIE = 3;

const styleCode: CSSProperties = { margin: 0, color: COULEURS.ardoise, fontSize: '0.85em' };
const styleIntitule: CSSProperties = { margin: '0 0 4px', fontWeight: 600 };
const styleListe: CSSProperties = { margin: '0 0 4px', paddingLeft: 20 };

export function DesignationDetaillee({ designation, libelle }: { designation: Designation | null; libelle?: string }): ReactElement {
  const [deplie, setDeplie] = useState(false);
  if (!designation) {
    return (
      <div data-designation="">
        <p style={styleIntitule}>{libelle ?? ''}</p>
      </div>
    );
  }
  const pliable = designation.detail.length > SECTIONS_AVANT_PLIAGE;
  const sections = pliable && !deplie ? designation.detail.slice(0, VISIBLES_PLIE) : designation.detail;
  return (
    <div data-designation="">
      {designation.code ? <p style={styleCode}>{designation.code}</p> : null}
      <p style={styleIntitule}>{designation.intitule}</p>
      {sections.length > 0 ? (
        <ul style={styleListe}>
          {sections.map((s, i) => (
            <li key={`${i}-${s.titre}`}>
              <strong>{s.titre}</strong>
              {s.lignes.length > 0 ? (
                <ul style={styleListe}>
                  {s.lignes.map((l, j) => (
                    <li key={`${j}-${l}`}>{l}</li>
                  ))}
                </ul>
              ) : null}
            </li>
          ))}
        </ul>
      ) : null}
      {pliable ? (
        <button type="button" style={styleBouton} aria-expanded={deplie} onClick={() => setDeplie(!deplie)}>
          {deplie ? 'Replier le détail' : `Afficher tout le détail (${designation.detail.length} sections)`}
        </button>
      ) : null}
    </div>
  );
}
